export default __webpack_public_path__ + "static/media/impact1.9ea13657.jpg";